<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <p class="order-title-boxs"><span class="blueBlock"></span><i>基本信息</i></p>
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            label-width="140px"
            label-position="left"
          >
                <el-form-item
                  class="el-form-item-add ml20"
                  ref="repairCateId"
                  label="出库原因："
                  prop="id"
                  :rules="$rules.required"
                >
                  <el-select v-model="form.id" placeholder="请选择" @change="onSubsidyType">
                    <el-option v-for="item in pullDownList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add ml20"
                  ref="remark"
                  label="出库备注："
                  prop="remark"
                >
                  <el-input v-model="form.remark" type="textarea" placeholder="请输入备注" maxlength="100" show-word-limit class="width200"></el-input>
                </el-form-item>
            
            <el-form-item class="el-form-item-add ml20" label="出库照片（1-3张）">
            </el-form-item>
            <imgUpload
                class="el-form-item-add ml20"
                @file="getImgFile"
                :limit="3"
                :fileList="form.imgUrlList"
                @delete="deleteImgFile"
                :imgHide="imgHide"
                module="inventory"
              ></imgUpload>

          </el-form>
        </div>

        <div class="align-items">
          <p class="order-title-boxs">
            <span class="blueBlock"></span><i>选择出库产品</i>
          </p>
          <span class="jishi fontSize16 pr16 cur" @click="seletGift">选择产品</span>
        </div>
        <div class="contents-body" v-if="itemList.length != 0">
          <el-row class="tables-title">
            <el-col :span="12" class="titles pl10">商品名称</el-col>
            <el-col :span="4" class="titles center">库存数量</el-col>
            <el-col :span="6" class="titles center">出库数量</el-col>
            <el-col :span="2" class="titles center">操作</el-col>
          </el-row>
          <div class="tables p30 scroll-auto">
            <div class="boxs" v-for="(item, index) in itemList" :key="index">
              <el-row>
                <el-col :span="12" class="color111 pl10">{{ item.name }}</el-col>
                <el-col :span="4" class="center">{{ item.inventoryNum }}</el-col>
                <el-col :span="6" class="center">
                  <p class="align-item">
                    <el-input
                    v-model="item.itemNum"
                    size="mini"
                    style="width: 80px;"
                    maxlength="8"
                    type="digit"
                    @input="inputChange(item)" 
                    @focus="inputFocus(item)"
                  ></el-input><span class="ml10" :class="[item.unit ? '' : 'pr10']">{{ item.unit || '' }}</span></p>
                </el-col>
                <el-col :span="2" class="detail right">
                  <i
                    class="el-icon-delete delete"
                    @click="deleteListSelected(item, index)"
                  ></i>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button type="primary" class="small-btn" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <selectGift ref="selectGift" @changeGift="giftCallback"></selectGift>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import imgUpload from "../../../components/common/modules/upload";
import selectGift from "./selectGift.vue";
export default {
  mixins: [minxin],
  components: { drawer, imgUpload, selectGift },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      form: {
        name: '',
        id: '',
        imgUrlList: [],
        remark: '',
      },
      oldAmount: '',
      pullDownList: [],
      imgHide: true,
      selectList: [],
      selectConsumeList: [],
      itemList: [],
    };
  },
  created() {
    this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.getTypeList();
        this.addEditTitle = "新增出库";
        this.addEditShow = true;
      });
  },
  methods: {
    getTypeList() {
        this.$api.post(this.$url.inventoryStorageInfo.pullDownList, {systemTag:'no',billType:'wastage'}).then(res => {
          if (res) {
            this.pullDownList = res;
          }
        });
    },
    back() {
      this.$refs["form"].resetFields()
      this.addEditShow = false;
    },
    getImgFile(res) {
      this.form.imgUrlList.push(res);
      if (this.form.imgUrlList.length >= 3) {
          this.imgHide = false
      }
    },
    deleteImgFile(res) {
      this.form.imgUrlList = res.myFileList;
      this.ossMerchatDelImg(res);
      if (this.form.imgUrlList.length < 3) {
          this.imgHide = true
      }
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    deleteListSelected(item, index) {
      // item.itemNum = Number(1);
      this.itemList.splice(index, 1);
    },
    onSubsidyType() {

    },
    seletGift() {
      // 选择赠品
      this.$refs["selectGift"].$emit("set", {'selectList':this.selectList,'selectConsumeList':this.selectConsumeList});
    },
    giftCallback(org) {
      // 选择赠品回调函数
      console.log('选择回调后数据：',org);
      if (org) {
        this.selectList = org.selectList;
        this.selectConsumeList = org.selectConsumeList;
        let arr = [];
        arr = arr.concat(org.selectList,org.selectConsumeList);
        this.itemList = arr;

        this.itemList.map((item) => {
        item.itemId = item.id;
        item.itemName = item.name;
        item.productId = item.id;
        item.productName = item.name;
        item.productCategoryId = item.categoryId
        item.productCategoryName = item.categoryName;
        item.productBarCode = item.barCode;
        item.storageUnit = item.unit;
        item.productType = item.productType;
        this.$set(item, "itemNum", item.itemNum ? item.itemNum : '');
        this.$set(item, "itemAmount", item.itemAmount ? item.itemAmount : '');
      });
      }
    },
    inputChange (item) {
      if (item.itemNum == '') {
        return;
      }
      if (item.itemNum > item.inventoryNum) {
        item.itemNum = this.oldAmount;
        this.$message.error("不能大于库存数据");
        return false;
      }
      var reg = /^[0-9]\d*$/g;
      if (!reg.test(item.itemNum)) {
        item.itemNum = this.oldAmount;
      } else {
        item.itemNum = Number(item.itemNum) + 0;
        this.oldAmount = item.itemNum;
      }
    },
    inputFocus (e) {
      this.oldAmount = e.checkNum;
    },
    onSubmit(values) {
        if (!this.form.id) {
          this.$message.error("请选择出库原因");
          return false;
        }
        if (this.itemList.length == 0) {
          this.$message.error("请选择产品");
          return false;
        }
        for (let index = 0; index < this.itemList.length; index++) {
          let item = this.itemList[index];
          if (item.itemNum == '' || item.itemNum <= 0) {
            this.$message.error("请填写出库数量");
            return;
          }
        }
        this.$api.post(this.$url.inventoryWastageInfo.save, {
            billCategoryId:this.form.id,
            remark:this.form.remark,
            imgUrlList:this.form.imgUrlList,
            itemFormList:this.itemList})
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("保存成功");
                this.$emit("change", true);
              }
            })
            .catch(error => {});
      },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.contents-body {
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .tables-title {
    font-size: 14px;
    margin: 0 16px;
    padding: 10px 0;
    font-size: 16px;
    font-weight: 600;
    background: #f7f8fa;
  }
  .tables {
    padding: 0 16px 0;
    max-height: 150px;
    box-sizing: border-box;
    .boxs {
      min-height: 65px;
      padding: 24px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ebedf0;
      .titles {
        font-weight: 500;
      }
      .money {
        color: @money;
        font-weight: 500;
      }
      .nums {
        /deep/.el-input-number {
          width: 80px;
          .el-input__inner {
            padding: 0 25px;
            height: 22px;
            line-height: 22px;
          }
        }
      }
      .delete {
        font-size: 18px;
        cursor: pointer;
        &:hover {
          color: @blue;
        }
      }
    }
    .right-content {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .staff-btn {
        display: inline-block;
        text-align: center;
        color: #111;
      }
    }
  }
}

.order-scoll {
  max-height: calc(100vh - 360px);
  overflow: auto;
}

.memberInfo {
  padding: 0 20px;
}
.pay-mains {
  padding: 0;
  overflow: hidden;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}

</style>